import Cookies from "js-cookie"

export const checkCookie = (cookieName: string): string | undefined => {
	return Cookies.get(cookieName)
}
